module.exports = "<vcm-landing *ngIf=\"landing\" [landing]=\"landing\"></vcm-landing>";